import { Routes } from '@angular/router';

export const AppRoutes: Routes = [
  { path: 'admin', loadChildren: './admin/admin.module#AdminModule' },
  { path: '', redirectTo: 'admin/login', pathMatch: 'full' },
  { path: '**', redirectTo: 'admin/login' }
];



// WEBPACK FOOTER //
// ./src/app/app.routing.ts